import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionService } from '../../../service/session/session.module';
import { LoadingService } from '../../../directive/loading/loading.module';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-admin-room-update',
  templateUrl: './admin-room-update.component.html',
  styleUrls: ['./admin-room-update.component.css']
})
export class AdminRoomUpdateComponent implements OnInit {
  @ViewChild('drawer',{static:true})drawerCtrl: MatDrawer;
  complexForm: FormGroup;
  zoneMin = {
    system:{
      company:{
        main:{
          uuid: ''
        }
      }
    },
    max: 10,
    offset: 0,
    filter:{
      name:'',
      value: ''
    }
  };
  floorModel = {
    main: {
      assignCalendar:false,
      uuid: '',
      nameOrNumber: '',
    },
    system: {
      floor: {
        main:{
          uuid: ''
        }
      },
      status: true
    }
  }
  object = JSON.parse(JSON.stringify(this.floorModel));
  zoneList =[];

  constructor(public fb: FormBuilder, private session: SessionService, public snackBar: MatSnackBar, private router: Router, private activatedRoute: ActivatedRoute, public loadingService:LoadingService) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.
      'nameOrNumber': [null, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(100)])],
    })
   }

  ngOnInit() {
    this.getlist();
    this.activatedRoute.params.subscribe((params: Params) => {
      if(params['uuid'] == 'new'){

      }else{
        this.loadingService.wait();
         this.object.main.uuid = params['uuid'];
         // cargamos los datos de la BD
         this.session.getRequest('room:get',this.object).subscribe((data:any)=>{
           this.object = JSON.parse(JSON.stringify(data.object));
           this.loadingService.hide();
         },
         (error)=>{
           this.loadingService.hide();
           console.log('Error:room:get',error)
         })

      }
    });
  }

  getlist(){
    // this.loadingService.wait();
    this.zoneList = [];
    // verificamos en que pagina verificamos
    this.zoneMin.system.company.main.uuid = this.session.getSessionObject().main.uuid;
    this.session.getRequest("floor:findAllByCompany", this.zoneMin).subscribe(
      (data: any) => {
        this.zoneList = data.object.instanceList;
        // this.loadingService.hide();
      },
      error => {
        console.log("floor:findAllByCompany", error);
        // this.loadingService.hide();
      }
    );
  }

  /*
  funcion para guardar un kit de producto
  */
  send(object){
    object.system.status = true;
    this.loadingService.show(true,'Guardando registro');
    this.session.getRequest("room:update",object).subscribe(
      (data:any) => {
        this.snackBar.open('El registro se guardo correctamente', '', {
          duration: 8000
        });
        this.loadingService.hide();
        this.router.navigate(['/admin/zone/list']);
     },
     error => {
       console.log("room:update",error);
       this.loadingService.hide();
     }
    );
  }
}
